module.exports = __webpack_public_path__ + "img/Fangxin Wang.4b6c5508.jpg";